import Iconify from "../iconify/Iconify";
import IconCode from "@/src/lib/iconCode";
import OtpInput from "react-otp-input";
import CustomButton from "@/src/lib/ui/Button";
import React, { useCallback, useEffect, useState } from "react";
import { headerApiService } from "@/src/lib/api-services/headerApiServices";
import Progressbar from "../loading";
import { userDetails } from "@/src/lib/store/user-details/slice";
import { updateHookCity } from "@/src/lib/store/hook-city/slice";
import { useDispatch } from "react-redux";
import { getLocation } from "@/src/lib/util/location";
import useCommon from "@/src/lib/util/useCommon";
import { useToast } from "@/src/lib/hooks/useToast";
import { myAccountApiService } from "@/src/lib/api-services/myAccountApiServices";
// import ConfirmDialog from "../confirm-dialog/ConfirmDialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import CreateMemberForm from "@/src/modules/my-account/members/add-member/createMemberForm";
import OtpTimer from "@/src/lib/util/otpTimer";
import { useRouter } from "next/router";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import CustomIconButton from "@/src/lib/ui/iconButton";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

const VerifyOtp = ({
    mobileNumber,
    setOtp,
    otp,
    setOpen = () => {}, // Default to a noop function,
    isAddPatientWithAnotherNumber,
    isTransferPatient = null,
    uId,
    refetch,
    handleClose,
    isLoginPage = false,
    redirectTo,
}) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const { cityLists } = useCommon();
    const { showCustomToast } = useToast();

    const [isOtp, isSetOtp] = useState("");
    const [isResendDisabled, setIsResendDisabled] = useState(true);

    const [getCurrentLocation, setGetCurrentLocation] = React.useState(false);
    const [openCreatePatientPopup, setOpenCreatePatientPopup] = useState(false);
    const [newUserInfo, setNewUserInfo] = useState(null);

    const isMobile = useBreakpoint("sm");

    const handleTimerComplete = useCallback(() => {
        setIsResendDisabled(false);
    }, []);

    const resendOtpHandler = () => {
        if (!isResendDisabled) {
            resendOtpMutation.mutate({ mobileNo: mobileNumber });
            setIsResendDisabled(true); // Disable resend button again
        }
    };

    const onEditHandler = () => {
        setOtp(false);
    };

    const closeCreatePatientPopupHandler = () => {
        handleClose();
        setOpenCreatePatientPopup(false);
    };

    const redirectToHome = () => {
        if (!!redirectTo) {
            router.push(redirectTo);
        } else {
            router.push("/my-account/my-orders");
        }
    };

    const validateOtpMutation = useHODMutation(
        (data) => headerApiService.validateOtp(data),
        {
            onSuccess: (data) => {
                if (data.success) {
                    const payload = {
                        mobileFrom: isTransferPatient.toString(),
                        mobileTo: mobileNumber,
                        uid: uId,
                    };

                    isTransferPatient &&
                        transferPatientMutation.mutate(payload);
                }
            },
            onError: (error) => {
                showCustomToast(error.response.data.message, "error");
            },
        }
    );

    const resendOtpMutation = useHODMutation(
        (data) => headerApiService.getOtp(data),
        {
            onSuccess: (data) => {
                setOtp(data?.data?.requestId);
                showCustomToast(data?.message, "success");
                setIsResendDisabled(true); // Disable resend button again
            },
            onError: (error) => {
                showCustomToast(error.response.data.message, "error");
            },
        }
    );

    const transferPatientMutation = useHODMutation(
        (data) => myAccountApiService.transferPatient(data),
        {
            onSuccess: (data) => {
                showCustomToast(data?.message, "success");
                refetch();
            },
            onError: (error) => {
                showCustomToast(error.response.data.message, "error");
            },
        }
    );

    useEffect(() => {
        const getCurrentPosition = async () => {
            try {
                const pos = await getLocation();
                setGetCurrentLocation(pos);
            } catch (error) {
                console.log(error, "error==========");
            }
        };
        getCurrentPosition();
    }, []);

    const mutation = useHODMutation((data) => headerApiService.sendOtp(data), {
        onSuccess: (data) => {
            const newUser = data?.data?.patientCount === 0;

            if (newUser) {
                const location = {
                    lat: getCurrentLocation.lat,
                    lng: getCurrentLocation.lng,
                };
                const info = { ...data?.data, mobileNumber, location };
                setNewUserInfo(info);
                setOpenCreatePatientPopup(true);
            } else {
                dispatch(userDetails(data?.data));
                const hookCity = cityLists?.find(
                    (city) => city?.cityId === data?.data?.centreDetails?.cityId
                );
                dispatch(updateHookCity(hookCity));
                setOtp("");
                showCustomToast(data?.message, "success");
                setOpen?.(false); // Using optional chaining
                isLoginPage && redirectToHome();
            }
        },
        onError: (error) => {
            showCustomToast(error.response.data.message, "error");
        },
    });

    const handleSendOtp = () => {
        const basePayload = {
            otp: Number(isOtp),
            requestId: otp,
        };

        const payloadWithLocation = {
            ...basePayload,
            location: {
                lat: getCurrentLocation.lat,
                lng: getCurrentLocation.lng,
            },
        };

        mutation.mutate(payloadWithLocation);
    };

    const handleTransferPatientOtp = () => {
        if (!isTransferPatient) return;

        const basePayload = {
            otp: Number(isOtp),
            requestId: otp,
        };

        const validateOtpPayload = {
            ...basePayload,
            mobileNo: mobileNumber,
        };

        validateOtpMutation.mutate(validateOtpPayload);
    };

    const handleAddMemberOtp = () => {
        console.log("addMemberOtpHandler");
    };

    const submitHandler = () => {
        if (isAddPatientWithAnotherNumber) {
            handleAddMemberOtp();
        } else if (isTransferPatient) {
            handleTransferPatientOtp();
        } else {
            handleSendOtp();
        }
    };

    return (
        <>
            <div>
                <h5 className="font-bold md:text-3xl text-xl">Enter OTP</h5>
                <h6 className="text-sm font-normal mt-1">
                    An OTP will be sent to your mobile number.
                </h6>
                <div className="flex flex-row items-center">
                    <h6 className="md:text-lg text-base text-primary font-bold mr-2">
                        {mobileNumber}
                    </h6>
                    <CustomIconButton
                        className="w-8 h-8 border border-solid border-primary p-1 hover:bg-primary"
                        onClick={onEditHandler}
                    >
                        <Iconify
                            icon={IconCode.edit}
                            className="text-primary hover:text-white"
                        />
                    </CustomIconButton>
                </div>

                <div className="md:py-8 py-4">
                    <OtpInput
                        value={isOtp}
                        onChange={isSetOtp}
                        inputStyle={{
                            width: "100%",
                            border: "1px solid #bbb",
                            borderRadius: "5px",
                            background: "#fff",
                            height: "51px",
                            color: "#000",
                        }}
                        inputType="number"
                        numInputs={6}
                        renderSeparator={<span>-</span>}
                        pattern="[0-9]*"
                        isInputNum={true}
                        renderInput={(props) => (
                            <input
                                {...props}
                                onKeyDown={(e) => {
                                    props.onKeyDown && props.onKeyDown(e);
                                    if (
                                        !e.defaultPrevented &&
                                        e.key === "Enter" &&
                                        !mutation.isLoading
                                    ) {
                                        e.preventDefault();
                                        submitHandler();
                                    }
                                }}
                            />
                        )}
                    />
                </div>

                <CustomButton
                    onClick={submitHandler}
                    variant="contained"
                    size="large"
                    fullWidth
                    disabled={mutation.isLoading}
                    className="flex items-center justify-center"
                >
                    {mutation.isLoading && (
                        <div className="mr-1">
                            <Progressbar size={20} />
                        </div>
                    )}{" "}
                    <p className="text-white"> Submit </p>
                </CustomButton>

                <div className="flex flex-row pt-4">
                    <h6 className="text-sm font-medium">Didn't receive OTP?</h6>
                    <h6 className="text-sm font-bold ml-1">
                        <span
                            style={{
                                fontWeight: "bold",
                                color: isResendDisabled ? "#C4CDD5" : "#c50000",
                                cursor: isResendDisabled
                                    ? "default"
                                    : "pointer",
                            }}
                            onClick={resendOtpHandler}
                        >
                            Resend
                        </span>
                        {isResendDisabled && (
                            <>
                                <span
                                    style={{
                                        fontWeight: "normal",
                                        color: "inherit",
                                    }}
                                >
                                    {" "}
                                    in{" "}
                                </span>
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        color: "#c50000",
                                    }}
                                >
                                    <OtpTimer
                                        initialTime={30}
                                        onTimerComplete={handleTimerComplete}
                                    />
                                </span>
                            </>
                        )}
                    </h6>
                </div>
            </div>
            <ConfirmDialog
                open={openCreatePatientPopup}
                fullScreen={isMobile}
                title={
                    <div className="flex justify-between items-center border-b border-gray-200 pb-4 -mx-5 px-5">
                        <h4 className="text-xl font-bold">
                            Create New Patient
                        </h4>

                        <CustomIconButton
                            onClick={closeCreatePatientPopupHandler}
                        >
                            <Iconify icon={IconCode.close} width={24} />
                        </CustomIconButton>
                    </div>
                }
                content={
                    <CreateMemberForm
                        isFirstUser={newUserInfo}
                        handleClose={closeCreatePatientPopupHandler}
                    />
                }
                maxWidth="lg"
                isCancel={true}
            />
        </>
    );
};
export default VerifyOtp;
